module.exports = __webpack_public_path__ + "static/media/menu_modelos_documento.35641e94.png";